var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { gql, useQuery } from '@apollo/client';
import { FilterProductEnum, callSideEffects } from '../../util';
import { currentFlightFilterSelectionsVar, defaultAvailableFlightFilters } from './currentFlightFilters';
import { mapToFlightFilterCriteria } from '../../util/filters/mapToFilterCriteria';
// Why do I have to pass a arg to CurrentHotelSearchParams?
const FLIGHT_FILTERS_QUERY = gql `
    query CurrentAvailableFlightFilters($tripStateId: ID!) {
        currentAvailableFlightFilters @client {
            ... on CheckboxFilterGroup {
                id
                name
                open
                type
                items {
                    id
                    selected
                    label
                    count
                }
                pill
            }
            ... on RangeFilterGroup {
                id
                name
                open
                type
                max
                min
                upper
                lower
                formatString
                step
                leadingText
            }
        }
    }
`;
export function useFilterFlights(sideEffects) {
    const setFlightFilters = (filters) => __awaiter(this, void 0, void 0, function* () {
        currentFlightFilterSelectionsVar(mapToFlightFilterCriteria(filters));
        callSideEffects(sideEffects, { product: FilterProductEnum.FLIGHT, filterGroups: filters });
    });
    const { data: queryData } = useQuery(FLIGHT_FILTERS_QUERY, {
        notifyOnNetworkStatusChange: true,
        ssr: false,
    });
    const availableFlightFilters = (queryData === null || queryData === void 0 ? void 0 : queryData.currentAvailableFlightFilters) || defaultAvailableFlightFilters;
    return [availableFlightFilters, setFlightFilters];
}
